import Repository from './Repository.js';

class UsersRepository extends Repository {
    async getUsers(query) {
        return await this.get('users', query);
    }
}

export default new UsersRepository();
